import {useEffect,useState} from 'react';
import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import { ToastContainer } from "react-toastify";
import copy from "copy-to-clipboard";

import Typography from '@mui/material/Typography';
import Breadcrumbs from '@mui/material/Breadcrumbs';
import Link from '@mui/material/Link';
import Divider from '@mui/material/Divider';
import Box  from '@mui/material/Box';
import Button from '@mui/material/Button';
import EmailIcon from '@mui/icons-material/Email';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
import TextField from '@mui/material/TextField';
import FormGroup from '@mui/material/FormGroup';
import FormControlLabel from '@mui/material/FormControlLabel';
import Switch from '@mui/material/Switch';
import Alert from '@mui/material/Alert';

import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import Paper from '@mui/material/Paper';
import Stack from '@mui/material/Stack';

import TopPrivateNavigation from '../components/TopPrivateNavigation.jsx'
import AppLogout from '../components/AppLogout.jsx'

//services
import AuthService from '../service/auth'
import ProjectService from '../service/Project'
import AccountProjectService from '../service/AccountProject'
import AccountInvite from '../service/AccountInvite'
import ResearcherAccountService from '../service/ResearcherAccount'

import PropTypes from 'prop-types';
//import Box from '@mui/material/Box';
import Collapse from '@mui/material/Collapse';
import IconButton from '@mui/material/IconButton';
//import Table from '@mui/material/Table';
//import TableBody from '@mui/material/TableBody';
//import TableCell from '@mui/material/TableCell';
//import TableContainer from '@mui/material/TableContainer';
//import TableHead from '@mui/material/TableHead';
//import TableRow from '@mui/material/TableRow';
//import Typography from '@mui/material/Typography';
//import Paper from '@mui/material/Paper';
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';
import KeyboardArrowUpIcon from '@mui/icons-material/KeyboardArrowUp';



function validateEmail(email){
  return String(email)
    .toLowerCase()
    .match(
      /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|.(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
    );
};

const formatJson=function(json){
	
	return JSON.stringify(json)
}

const formatDate=function(d){
	var d = new Date(d);
	Number.prototype.padLeft = function(base,chr){
    var  len = (String(base || 10).length - String(this).length)+1;
    return len > 0? new Array(len).join(chr || '0')+this : this;
}
    var dformat = [
               d.getDate().padLeft(),
			   (d.getMonth()+1).padLeft(),
               d.getFullYear()].join('/') +' ' +
              [d.getHours().padLeft(),
               d.getMinutes().padLeft()].join(':');
	return dformat;
}

const Researchers = () => {
	
	const navigate = useNavigate();
	//protected page check if logged in
	const [currentUser,setCurrentUser]=useState({});
	const [projectData,setProjectData]=useState([]);
	const [projectFound,setProjectFound]=useState(false);
	
	const [projectList,setProjectList]=useState([]);
	const [tempResearcher,setTempResearcher]=useState({});
	const [researcherProjects,setResearcherProjects]=useState([]);
	const [researcherAccountProjects,setResearcherAccountProjects]=useState([]);
	//let params = useParams();
	let project_id =ProjectService.getCurrentProject();//params.id;
	console.log('project_id',project_id);
	
	const [researcherAcountsData,setResearchersData]=useState([]);
	const [researcherProjectsData,setResearchersProjectsData]=useState({});
	function loadResearchersByProject(project_id){//by account
		AccountProjectService.getByFilter({'project':project_id,'account_type':'Researcher'}).then(function(res){
			console.log('res.data',res.data);
			var _accounts=res.data;
			var _accs=[];
			for(var i=0;i<_accounts.length;i++){
				console.log(_accounts[i].account);
				_accs.push(_accounts[i].account);
			}
			setResearchersData(_accs);

		}).catch(function(error){
				console.log(error);
		});
	};
	
	function loadAllResearchers(){
		ResearcherAccountService.getAll().then(function(res){
			console.log(res.data);
			setResearchersData(res.data);
		}).catch(function(error){
				console.log(error);
		});
	};
	
	function loadResearchersByAllProjects(){
		AccountProjectService.getByFilter({'account_type':'Researcher'}).then(function(res){
			console.log(res.data);
			var _accounts=res.data;
			var _projects={};
			for(var i=0;i<_accounts.length;i++){
				console.log(_accounts[i].account.id);
				if(typeof _projects[_accounts[i].account.id]=="undefined"){
					_projects[_accounts[i].account.id]=[];
				}
				_projects[_accounts[i].account.id].push(_accounts[i].project);
			}
			console.log(_projects);
			setResearchersProjectsData(_projects);
			//setResearchersData(res.data);

		}).catch(function(error){
				console.log(error);
		});
	};
	
	function loadResearchersProjects(researcher){
		
		ProjectService.getByFilter({'is_private':false}).then(function(res1){
		setProjectList(res1.data);
		console.log(res1.data);
		
				
			AccountProjectService.getByFilter({'account':researcher._id,'account_type':'Researcher'}).then(function(res){
				console.log('res.data',res.data);
				var _accounts=res.data;
				var _accs={};
				var _apccs={};
				for(var i=0;i<res1.data.length;i++){
					_accs[res1.data[i].id]=false;
					_apccs[res1.data[i].id]=null;
				}
				
				for(var i=0;i<_accounts.length;i++){
					_accs[_accounts[i].project.id]=true;
					_apccs[_accounts[i].project.id]=_accounts[i].id;
				}
				setResearcherProjects(_accs);
				setResearcherAccountProjects(_apccs);
				setManageProjectsModalOpen(true);

			}).catch(function(error){
					console.log(error);
			});

		}).catch(function(error1){
			console.log(error1);
			setProjectFound(false);
		});
		
	
	};

	
	useEffect(() => {
		if(!AuthService.isUserLoggedIn()){
			// not logged in navigate back to login
			navigate("/login");
		}else{
				setCurrentUser(AuthService.getCurrentUser());
				var account_type=AuthService.getCurrentUser().__t;
				console.log('account_type',account_type);
				
				console.log(AuthService.getCurrentUser());
				var currentUser=AuthService.getCurrentUser();
				//expired Account
				if(currentUser.expired){
					var string = "account_type="+AuthService.getCurrentUser().__t+"&type=expired";
					console.log('string',string);
					var encodedString = btoa(string); // Base64 encode the String
					console.log('encodedString',encodedString);
					navigate("/restricted/"+encodedString);
					
				}else{//unverified account
					if(!currentUser.email_verified){
						var string = "account_type="+AuthService.getCurrentUser().__t+"&type=emaiverification";
						console.log('string',string);
						var encodedString = btoa(string); // Base64 encode the String
						console.log('encodedString',encodedString);
						navigate("/restricted/"+encodedString);
						
					}else{////force change Password
						if(currentUser.force_password_change){
							//not implemented	
						
						}else{
							//load project if set 
							if((typeof project_id !=="undefined")&&(project_id!==null)){//project filter
								loadProjectById(project_id);
							}
							//load
							if(account_type=='Admin'){//Admin
								loadAccountInvites();
							}else if(account_type=='Master'){//Master
								//loadProjects();
								if((typeof project_id !=="undefined")&&(project_id!==null)){//project filter
									loadResearchersByProject(project_id);
									//loadAccountInvitesByProjectId();
								}else{
									loadAllResearchers();
									loadResearchersByAllProjects();
								}
							}else if(account_type=='Researcher'){//Researcher
								loadAllResearchers();
								loadResearchersByAllProjects();
							}
						}
					}
				}	
		}
	}, []);
	
	function loadProjectById(project_id){
		ProjectService.getById(project_id).then(function(res){
		setProjectData(res.data);
		console.log(res.data);
		setProjectFound(true);
		}).catch(function(error){
			console.log(error);
			setProjectFound(false);
		});
	}
	
	function loadProjects(){
		ProjectService.getByFilter({'is_private':false}).then(function(res){
		setProjectList(res.data);
		console.log(res.data);
		}).catch(function(error){
			console.log(error);
			setProjectFound(false);
		});
	}
	
	const [accountInviteData,setAccountInviteData]=useState([]);
	function loadAccountInvitesByProjectId(){
		AccountInvite.getByFilter({'project':project_id,'account_type':'Researcher','invited_by':AuthService.getCurrentUser()._id,'accepted':false}).then(function(res){
			console.log(res.data);
			setAccountInviteData(res.data);
		}).catch(function(error){
				console.log(error);
		});
	};
	
	function loadAccountInvites(){
		AccountInvite.getByFilter({'accepted':false}).then(function(res){
			console.log(res.data);
			setAccountInviteData(res.data);
		}).catch(function(error){
				console.log(error);
		});
	};
	
	function resendResearcherInvite(id){
		AccountInvite.resendResearcherInvite(id).then(function(res){
			console.log(res.data);
		}).catch(function(error){
				console.log(error);
		});
	};
	
	//new researcher project invite  
	const [openNewInviteModal, setNewInviteModalOpen] = useState(false);

	const handleNewInviteModalOpen = () => {
		setNewInviteModalOpen(true);
	};

	const handleNewInviteModalClose = () => {
		setNewInviteModalOpen(false);
	};
	//
	const handleResendInvite = (e,invite) => {
		clearAlertMessages();
			console.log('invite',invite);
			AccountInvite.resendResearcherInvite(invite).then(function(res){
				console.log(res.data);
				toast.success("Sending invite");
	
			}).catch(function(error){
					console.log(error);
			});
	};
	
	
	const handleCopyLink = (e,invite) => {
		clearAlertMessages();
			console.log('invite',invite);
			AccountInvite.getResearcherInviteLink(invite).then(function(res){
				console.log(res.data);
				
				
				let isCopy = copy(res.data.url);

					//Dispalying notification
					if (isCopy) {
					  toast.success("Copied to Clipboard");
					}
	
	
			}).catch(function(error){
					console.log(error);
			});
	};
	
	const [openManageProjectsModal, setManageProjectsModalOpen] = useState(false);	  
	const handleManageProjectsModal = (e,user) => {
		setTempResearcher(user);
		clearAlertMessages();
		//loadProjects();
		loadResearchersProjects(user);
		
		
	};
	
	const handleManageProjectsModalClose= (e) => {
		clearAlertMessages();
		setManageProjectsModalOpen(false);
	};
	
	
	const handleRemoveFromProject= (e,accountProject) => {
		clearAlertMessages();
	//	console.log('project',project);
		console.log('tempResearcher',tempResearcher);
		//setManageProjectsModalOpen(false);
		
		AccountProjectService.deleteById(accountProject).then(function(res){
				console.log('res.data',res.data);
					loadResearchersProjects(tempResearcher);
			}).catch(function(error){
					console.log(error);
			});
	};
	
	const handleAddToProject= (e,project) => {
		clearAlertMessages();
		console.log('project',project);
		console.log('tempResearcher',tempResearcher);
		//setManageProjectsModalOpen(false);
		
		
		
			AccountProjectService.add({'account':tempResearcher,'account_type':'Researcher','project':project,'created_by':AuthService.getCurrentUser()._id}).then(function(res){
				console.log('res.data',res.data);
				loadResearchersProjects(tempResearcher);
			}).catch(function(error){
					console.log(error);
			});
	};
	
	//
	const [ShowErrorMessage,setErrorStatus]=useState(false); 
	const [ErrorText,setErrorMessage]=useState(""); 
	
	const [ShowSuccessMessage,setSuccessStatus]=useState(false); 
	const [SuccessText,setSuccessMessage]=useState("");
	
	function clearAlertMessages(){	
		setErrorStatus(false);
		setErrorMessage("");
		setSuccessStatus(false);
		setSuccessMessage("");
	}
		  
	const handleNewResearcherInviteModalOpen = () => {
		loadAccountInvitesByProjectId();
		setNewInviteModalOpen(true);
		clearAlertMessages();
	};
	
	const [firstName,setFirstName]=useState('');
	const handleFirstNameChange = (event) => {
		setFirstName(event.target.value);
	};
	const [lastName,setLastName]=useState('');
	const handleLastNameChange = (event) => {
		setLastName(event.target.value);
	};
	const [email,setEmail]=useState('');
	const handleEmailChange = (event) => {
		setEmail(event.target.value);
	};

	
	const handleSubmitNewInvite=(event: React.FormEvent<HTMLFormElement>) => {
		clearAlertMessages()
		event.preventDefault();
		const data = new FormData(event.currentTarget);
		console.log(data);
		var invite={'first_name':data.get('first_name'),
					'last_name':data.get('last_name'),
					'email':data.get('email'),
					'invited_by':AuthService.getCurrentUser()._id,
					'project':project_id,
					'account_type':'Researcher'
		};
		console.log('invite',invite);
		if((invite.first_name!=="") && (invite.last_name!=="") && (validateEmail(invite.email))){
				console.log('valid',invite);
				AccountInvite.create(invite).then(function(res){
					console.log(res.data);
					setSuccessStatus(true);
					setSuccessMessage("Invite sent");
					
					setFirstName('');
					setLastName('');
					setEmail('');
					
					loadAccountInvites();
					loadAccountInvitesByProjectId();
				}).catch(function(error){
					console.log(error);
					setErrorStatus(true);
		setErrorMessage(error.response.data.message);

				});
		}else{
			console.log('invalid',invite);
			setErrorStatus(true);
			setErrorMessage("Please ensure all required fields are completed correctly!!");
		}
		
		

	};
	

  return(
  <>
	<TopPrivateNavigation/>
	<AppLogout>
	
	<ToastContainer
      position="top-center"
      autoClose={500}
      hideProgressBar
      newestOnTop={false}
      closeOnClick
      rtl={false}
      pauseOnFocusLoss
      draggable
      pauseOnHover
      theme="colored"
    />
	
		{/* error no project found */}
	{(!projectFound) ?
		<>
		
		<br/>
		<Breadcrumbs aria-label="breadcrumb">
        <Link underline="hover" color="inherit" href="/">
          Home
        </Link>
		 <Typography color="text.primary">Researchers</Typography>
      </Breadcrumbs>
	  
	  <br/>
	  <Divider />
		<br/>
		
		
		</>
	:<></>}
	{/* if project is found */}
	{(projectFound) ?
	<>
		<br/>
		<Breadcrumbs aria-label="breadcrumb">
        <Link underline="hover" color="inherit" href="/">
          Home
        </Link>
        <Link
          underline="hover"
          color="inherit"
          href="/projects"
        >
          Projects
        </Link>
		<Link
          underline="hover"
          color="inherit"
          href={`/project/${projectData._id}`}
        >
          {projectData.name}
        </Link>
		 <Typography color="text.primary">Researchers</Typography>
      </Breadcrumbs>
	  
	  <br/>
	  <Divider />
		
	
	</>
	:<></>}
	
	{(projectFound) ?
	<>
	
	
	<div style={{ width: '100%' }}>
      <Box
        sx={{
          display: 'flex',
          flexDirection: 'row-reverse',
          p: 1,
          m: 1,
         // bgcolor: 'background.paper',
          borderRadius: 1,
        }}
      >
	  {(!projectData.is_private) ?
	  <>
        <Button onClick={handleNewResearcherInviteModalOpen}   variant="outlined" startIcon={<EmailIcon/>}>
		  Send Invite
		</Button>
	  </>:<></>}
		
		{/* manage project settings dialog */}
		<Dialog
        open={openNewInviteModal}
		maxWidth='lg'
		fullWidth={true}
      >
	  <Box component="form" onSubmit={handleSubmitNewInvite}  noValidate sx={{ mt: 1 }}>
        <DialogTitle>New Invite</DialogTitle>
        <DialogContent>
          <DialogContentText>
			
          </DialogContentText>
		   { ShowErrorMessage &&
				<Alert variant="filled" severity="error">{ErrorText}</Alert>
			} 
			{ ShowSuccessMessage &&
				<Alert variant="filled" severity="success">{SuccessText}</Alert>
			}
			<br/>
			
			{(accountInviteData.length==0) ?
			<>
			No pending invites!
			</>:<>
			{accountInviteData.length} pending invite(s)<br/>
				<TableContainer >
				  <Table sx={{ width:'100%'}} aria-label="simple table">
					<TableHead>
					<TableRow>
						<TableCell>First Name</TableCell>
						<TableCell>Last Name</TableCell>
						<TableCell>Email</TableCell>
						<TableCell>Invited by</TableCell>
						<TableCell></TableCell>
					  </TableRow>
					</TableHead>
					   <TableBody>
						{accountInviteData.map((row,index) => (
						<TableRow key={row._id} sx={{ '&:last-child td, &:last-child th': { border: 0 } }}>
						  <TableCell align="left">{row.first_name}</TableCell>
						  <TableCell align="left">{row.last_name}</TableCell>
						  <TableCell align="left">{row.email}</TableCell>
						  <TableCell align="left">{row.invited_by.first_name}{row.invited_by.last_name}<br/>{formatDate(row.date_invited)}</TableCell>
						  <TableCell align="left">
							<Button  onClick={(e) => handleResendInvite(e,row)}  variant="outlined">Resend</Button> &nbsp;
								{/*	<Button  onClick={(e) => handleCopyLink(e,row)}  variant="outlined">Copy Link</Button>*/}
						  </TableCell>
						</TableRow>
						))}
				  
					</TableBody>
					</Table>
				</TableContainer>
			</>}
		  
          <TextField
				  margin="normal"
				  required
				  fullWidth
				  id="first_name"
				  label="First Name"
				  name="first_name"
				  value={firstName}
				  onChange={handleFirstNameChange}
				/>
		  <br/>
		   <TextField
				  margin="normal"
				  required
				  fullWidth
				  id="last_name"
				  label="Last Name"
				  name="last_name"
				  value={lastName}
				   onChange={handleLastNameChange}
				/>
		  <br/>
		   <TextField
				  margin="normal"
				  required
				  fullWidth
				  id="email"
				  label="Email"
				  name="email"
				  autoComplete="email"
				  value={email}
				   onChange={handleEmailChange}
				/>
		  <br/>
			
				
        </DialogContent>
        <DialogActions>
          <Button onClick={handleNewInviteModalClose}   variant="outlined">Close</Button>
		  <Button endIcon={<EmailIcon/>} type="submit"   variant="outlined">Send</Button>
        </DialogActions>
		</Box>
      </Dialog>
	  
	 
      </Box>

    </div>
	</>
	:<>
	
	
	 {/* manage projects dialog */}
		<Dialog
        open={openManageProjectsModal}
		maxWidth='sm'
		fullWidth={true}
      >
	  <Box component="form" onSubmit={handleSubmitNewInvite}  noValidate sx={{ mt: 1 }}>
        <DialogTitle>Manage Projects for {tempResearcher.first_name} {tempResearcher.last_name} ({tempResearcher.email})</DialogTitle>
        <DialogContent>
          <DialogContentText>
          </DialogContentText>
		   { ShowErrorMessage &&
				<Alert variant="filled" severity="error">{ErrorText}</Alert>
			} 
			{ ShowSuccessMessage &&
				<Alert variant="filled" severity="success">{SuccessText}</Alert>
			}
			<br/>
			
				<TableContainer >
				  <Table sx={{ width:'100%'}} aria-label="simple table">
					<TableHead>
					<TableRow>
						<TableCell>Project</TableCell>
						<TableCell></TableCell>
					  </TableRow>
					</TableHead>
					   <TableBody>
						{projectList.map((project,index) => (
						<TableRow key={project._id} sx={{ '&:last-child td, &:last-child th': { border: 0 } }}>
						  <TableCell align="left">{project.name}</TableCell>
						  <TableCell align="center">
							{researcherProjects[project.id] ? 
							<>
								<Button  
									onClick={(e) => handleRemoveFromProject(e,researcherAccountProjects[project.id])}  
									variant="outlined"
									color="error"
								>
								Remove
								</Button>
							</>:<>
								<Button  
									onClick={(e) => handleAddToProject(e,project)}  
									variant="outlined"
									color="success"
								>
								Add
								</Button>
							</>}
							</TableCell>

						  <TableCell align="left">
					
						  </TableCell>
						</TableRow>
						))}
				  
					</TableBody>
					</Table>
				</TableContainer>
			

        </DialogContent>
        <DialogActions>
          <Button onClick={handleManageProjectsModalClose}   variant="outlined">Close</Button>
        </DialogActions>
		</Box>
      </Dialog>

	
	
	
	
	
	</>}

	
	{/* Admin */}
	{(currentUser.__t=='Admin') ?
	<>
	
	{(accountInviteData.length==0) ?
			<>
			No pending invites!
			</>:<>
			{accountInviteData.length} pending invite(s)<br/>
				<TableContainer >
				  <Table sx={{ width:'100%'}} aria-label="simple table">
					<TableHead>
					<TableRow>
						<TableCell>First Name</TableCell>
						<TableCell>Last Name</TableCell>
						<TableCell>Email</TableCell>
						<TableCell>Project</TableCell>
						<TableCell>Invited By</TableCell>
						<TableCell></TableCell>
					  </TableRow>
					</TableHead>
					   <TableBody>
						{accountInviteData.map((row,index) => (
						<TableRow key={row._id} sx={{ '&:last-child td, &:last-child th': { border: 0 } }}>
						  <TableCell align="left">{row.first_name}</TableCell>
						  <TableCell align="left">{row.last_name}</TableCell>
						  <TableCell align="left">{row.email}</TableCell>
						  <TableCell align="left">{row.project.name}</TableCell>
						  <TableCell align="left">{row.invited_by.first_name} {row.invited_by.last_name}</TableCell>
						  <TableCell align="left">
							<Button  onClick={(e) => handleResendInvite(e,row)}  variant="outlined">Resend</Button> &nbsp;
							<Button  onClick={(e) => handleCopyLink(e,row)}  variant="outlined">Copy Link</Button>
						  </TableCell>
						</TableRow>
						))}
				  
					</TableBody>
					</Table>
				</TableContainer>
			</>}
	
	</>
	:<></>}
	
	{/* Master */}
	{(currentUser.__t=='Master') ?
	<>
	
		{(projectFound) ?
		<>
		
		</>
		:<>
		
		</>}
		
			
			{(researcherAcountsData.length==0) ?
			<>None found!</>
				:<>
				<TableContainer component={Paper}>
				  <Table sx={{ minWidth: 650,width:'100%'}} aria-label="simple table">
					<TableHead>
					<TableRow>
						<TableCell>First Name</TableCell>
						<TableCell>Last Name</TableCell>
						<TableCell>Email</TableCell>
						<TableCell>Last Logged In</TableCell>
							  
						{(projectFound) ?
						<></>:<>  
						<TableCell>Projects</TableCell>
						</>}
						<TableCell></TableCell>
					  </TableRow>
					</TableHead>
					   <TableBody>
						{researcherAcountsData.map((row,index) => (
						<TableRow key={row._id} sx={{ '&:last-child td, &:last-child th': { border: 0 } }}>
						  <TableCell align="left">{row.first_name}</TableCell>
						  <TableCell align="left">{row.last_name}</TableCell>
						  <TableCell align="left">{row.email}</TableCell>
						  <TableCell align="left">{formatDate(row.last_logged_in)}</TableCell>
						  
						{(projectFound) ?
						<></>:<>  
						  <TableCell align="left">
						 
						
						
						<Link
						  component="button"
						  variant="body2"
						  onClick={(e) => handleManageProjectsModal(e,row)}
						>
						  Manage Projects
						</Link>
						<br/>
						
						
						

						  </TableCell>
					</>}
						</TableRow>
						))}
				  
					</TableBody>
					</Table>
				</TableContainer>
			</>
			}
				
	
	</>
	:<></>}
	
	{/* Researcher */}
	{(currentUser.__t=='Researcher') ?
	<>
	
		{(projectFound) ?
		<>
		
		</>
		:<>
		
		</>}
	
			{(researcherAcountsData.length==0) ?
				<>None found!</>
				:<>
				<TableContainer component={Paper}>
				  <Table sx={{ minWidth: 650,width:'90%'}} aria-label="simple table">
					<TableHead>
					<TableRow>
						<TableCell>First Name</TableCell>
						<TableCell>Last Name</TableCell>
						<TableCell>Email</TableCell>
						<TableCell>Last Logged In</TableCell>
					  </TableRow>
					</TableHead>
					   <TableBody>
						{researcherAcountsData.map((row,index) => (
						<TableRow key={row._id} sx={{ '&:last-child td, &:last-child th': { border: 0 } }}>
						  <TableCell align="left">{row.first_name}</TableCell>
						  <TableCell align="left">{row.last_name}</TableCell>
						  <TableCell align="left">{row.email}</TableCell>
						  <TableCell align="left">{formatDate(row.last_logged_in)}</TableCell>
				
						</TableRow>
						))}
				  
					</TableBody>
					</Table>
				</TableContainer>
				</>
				}
	
	</>
	:<></>}

	</AppLogout>
	</>
  ) 
  ;
};

export default Researchers;